import React from "react";

// Per-day fines of one leave: projected while pending, recorded once
// approved or marked absent.

const PenaltyBreakdownModal = ({ leave, onClose }) => {
  const total = leave.status === "PENDING" ? leave.projectedPenaltyAmount : leave.penaltyAmount;
  const rows = leave.penaltyBreakdown || [];

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 w-[500px] shadow-xl max-h-[90vh] overflow-y-auto">
        <h2 className="text-xl font-bold mb-4 text-gray-800 border-b pb-2">Penalty Breakdown</h2>
        <div className="mb-4">
          <span className="text-sm font-semibold text-gray-700">Total Penalty: </span>
          <span className="text-sm font-bold text-red-600">₹{total}</span>
        </div>

        {rows.length > 0 ? (
          <div className="overflow-hidden border rounded-lg">
            <table className="min-w-full text-left text-sm text-gray-600">
              <thead className="bg-gray-50 text-gray-700 font-bold border-b">
                <tr>
                  <th className="py-2 px-3">Date</th>
                  <th className="py-2 px-3">Reason</th>
                  <th className="py-2 px-3 text-right">Deduction</th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {rows.map((item, idx) => (
                  <tr key={idx} className="hover:bg-gray-50 transition">
                    <td className="py-2 px-3 font-medium">{item.date}</td>
                    <td className="py-2 px-3 text-xs">{item.reason}</td>
                    <td className="py-2 px-3 text-right font-bold text-red-600">₹{item.penaltyAmount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-sm text-gray-500 italic">No breakdown details available.</p>
        )}

        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border rounded text-sm font-medium hover:bg-gray-100 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PenaltyBreakdownModal;
